"use strict";

exports.__esModule = true;
var _RestAPI = require("./RestAPI");
Object.keys(_RestAPI).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _RestAPI[key]) return;
  exports[key] = _RestAPI[key];
});
var _RestAPIContext = require("./RestAPIContext");
Object.keys(_RestAPIContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _RestAPIContext[key]) return;
  exports[key] = _RestAPIContext[key];
});
var _useRestApi = require("./useRestApi");
Object.keys(_useRestApi).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useRestApi[key]) return;
  exports[key] = _useRestApi[key];
});
var _useRequestPromiseLoader = require("./useRequestPromiseLoader");
Object.keys(_useRequestPromiseLoader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useRequestPromiseLoader[key]) return;
  exports[key] = _useRequestPromiseLoader[key];
});